import { render, staticRenderFns } from "./BannerWelcome.vue?vue&type=template&id=f99229f4&"
import script from "./BannerWelcome.vue?vue&type=script&lang=js&"
export * from "./BannerWelcome.vue?vue&type=script&lang=js&"
import style0 from "./BannerWelcome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BannerWelcome.vue"
export default component.exports